import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../api';
import PropertyCard from '../components/PropertyCard';

const SavedPropertiesPage = () => {
  const { getAuthHeader } = useAuth();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSavedProperties();
  }, []);

  const loadSavedProperties = async () => {
    setLoading(true);
    try {
      const response = await api.getSavedProperties(getAuthHeader());
      setProperties(response.data);
    } catch (error) {
      console.error('Error loading saved properties:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="saved-properties-page">
      <h2 className="text-2xl font-semibold mb-6 font-heading">
        Saved Properties ({properties.length})
      </h2>

      {loading ? (
        <div className="text-center py-12">
          <p className="text-slate-600">Loading saved properties...</p>
        </div>
      ) : properties.length === 0 ? (
        <div className="text-center py-12 bg-slate-50 rounded-sm">
          <p className="text-slate-600">You haven't saved any properties yet.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {properties.map((property) => (
            <PropertyCard 
              key={property.property_id} 
              property={property}
              isSaved={true}
              onSaveToggle={loadSavedProperties}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SavedPropertiesPage;